module.exports = __webpack_public_path__ + "img/The_Spotted_Cow@3x.7302c3a9.png";